import React from "react";


function Intrests() {
    return (
        <div>
            <h6 className="intrests">Intrests</h6>
            <p className="intrests-info">Food expert. Music scholar. Reader. Internet fanatic. Bacon buff. Entrepreneur. Travel geek. Pop culture ninja. Coffee fanatic.</p>
        </div>
)
}

export default Intrests;